import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "../../App.css"
import { validateEmail } from '../../common/utils/format';
import api from '../../common/api';

export default function Support() {
    const { t } = useTranslation();
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [issue, setIssue] = useState(t('support.options.feedback'))
    const [detail, setDetail] = useState('')
    const [isValidEmail, setIsValidEmail] = useState(false);
    const [shake, setShake] = useState(false)

    const onPress = async () => {
        if (
            !name ||
            !email ||
            !isValidEmail ||
            !detail
        ) {
            setShake(true)
            setTimeout(() => {
                setShake(false)
            }, 300)
            return;
        }

        const data = { name, email, issue, detail }
        const res = await api.supportForm(data);

        if (res.status === 'Ok') {
            document.getElementById("ads-dialog").style.display = 'flex';
        }
    }

    return (
        <div className="content">
            <div className={ `help support_main_container ${shake ? 'shake' : null}` } >
                <div className="left">
                    <h2>{ t('support.title') }</h2>
                    <p>{ t('support.desc') }<br />{ t('support.desc2') }</p>
                </div>
                <div className="right">
                    <div className="each_fieldset">
                        <label>{ t('support.name') }{ !name && <span className="req">*</span> }</label>
                        <div className="input_ele">
                            <input
                                type="text"
                                required
                                name="name"
                                placeholder="John Doe"
                                onChange={ (e) => {
                                    setName(e.target.value);
                                } }
                            />
                        </div>
                    </div>
                    <div className="each_fieldset">
                        <label>{ t('support.email') }<span className="req">*</span></label>
                        <div className="input_ele">
                            <input
                                type="email"
                                required
                                name="email"
                                placeholder="john.doe@email.com"
                                onChange={ (e) => {
                                    const newEmail = e.target.value;
                                    setEmail(newEmail);
                                    setIsValidEmail(validateEmail(newEmail));
                                } }
                            />
                        </div>
                    </div>
                    <div className="each_fieldset">
                        <label>{ t('support.issue') }</label>
                        <div className="input_ele">
                            <select value={ issue } onChange={ (e) => setIssue(e.target.value) }>
                                <option>{ t('support.options.feedback') }</option>
                                <option>{ t('support.options.request') }</option>
                                <option>{ t('support.options.bug') }</option>
                                <option>{ t('support.options.others') }</option>
                            </select>
                        </div>
                    </div>
                    <div className="each_fieldset">
                        <label>{ t('support.details') } <span className="req">*</span></label>
                        <div className="input_ele">
                            <textarea
                                placeholder={ t('support.placehoder') }
                                required
                                rows="5"
                                value={ detail }
                                onChange={ (e) => {
                                    setDetail(e.target.value);
                                } }
                            ></textarea>
                        </div>
                    </div>
                    <div className="bottom">
                        <button onClick={ onPress }>
                            { t('support.submit') }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}